export default {
  permissions: [],
  pagination: {},
  profile: null,
  profiles: [],
  partners: [],
  invitesSent: [],
  myColabs: {},
  invite: null,
  invitesReceived: {}
};
